/* eslint-disable */
export default {
  cancel: 'Cancel',
  reply: 'Reply',
  onMyWay: 'On my way',
  customMessage: 'Custom Message',
  callMeBackIn: 'Call me back in',
  willCallYouBackIn: 'Will call you back in',
  min: 'min',
  hours: 'hours',
  days: 'days',
} as const;

// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"reply"@#@ @source: @#@"Reply"@#@
// @key: @#@"onMyWay"@#@ @source: @#@"On my way"@#@
// @key: @#@"customMessage"@#@ @source: @#@"Custom Message"@#@
// @key: @#@"callMeBackIn"@#@ @source: @#@"Call me back in"@#@
// @key: @#@"willCallYouBackIn"@#@ @source: @#@"Will call you back in"@#@
// @key: @#@"min"@#@ @source: @#@"min"@#@
// @key: @#@"hours"@#@ @source: @#@"hours"@#@
// @key: @#@"days"@#@ @source: @#@"days"@#@
